import React, { useEffect } from 'react';

const Loading = () => {
  useEffect(() => {
    const loadingScreen = document.getElementById('loading-screen');
    const loadingVideo = document.getElementById('loading-video');

    if (!loadingVideo) return;

    // Wybierz źródło na podstawie szerokości okna
    const isMobile = window.matchMedia('(max-width: 450px)').matches;
    const source = document.createElement('source');
    source.src = isMobile ? '/videos/intro-mobile.webm' : '/videos/video4.mp4';
    source.type = isMobile ? 'video/webm' : 'video/mp4';

    // Wyczyść i dodaj źródło
    loadingVideo.innerHTML = '';
    loadingVideo.appendChild(source);

    const onTimeUpdate = () => {
      const currentTime = loadingVideo.currentTime;
      if (currentTime >= 5.23 && currentTime <= 6.21) {
        loadingScreen.classList.add('opacity-0', 'pointer-events-none');
      }
      if (currentTime > 6.21) {
        loadingScreen.style.display = 'none';
      }
    };

    loadingVideo.addEventListener('timeupdate', onTimeUpdate);

    loadingVideo.load(); // ważne po dodaniu <source>
    loadingVideo.play().catch(err => console.error('Video play error:', err));

    return () => {
      loadingVideo.removeEventListener('timeupdate', onTimeUpdate);
    };
  }, []);

  return (
    <div
      id="loading-screen"
      className="fixed top-0 left-0 w-full h-full bg-[#FFFF00] flex justify-center items-center z-[2000] transition-opacity duration-1000"
    >
      <video
        id="loading-video"
        className="w-full h-auto object-cover mq450:object-contain"
        autoPlay
        muted
        playsInline
        preload="auto"
      />
    </div>
  );
};

export default Loading;
